import { useUser } from '../../../hooks/useUser';
import { useGetCalculationConfigurationQuery } from '../../../apis/apiGlobalConfiguration';
import { IconButton_IconSizes, Row, Title } from '@ydistri/ds';
import { MdLockOutline } from 'react-icons/md';
import { Popover } from 'antd';
import React from 'react';
import { COLORS } from '@ydistri/theme';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

const TemplateLockedAlert: React.FC = () => {
  const user = useUser();
  const templateOrCalculation = useTemplateOrCalculationWithValue();
  const { data, isFetching } = useGetCalculationConfigurationQuery(templateOrCalculation.value);

  if (isFetching || !data) {
    return null;
  }

  if (!data.isLocked) {
    return null;
  }

  let tooltipMessage: string;
  if (user?.isSuperUser) {
    tooltipMessage = 'Template is locked and cannot be changed. Unlock it to make modifications.';
  } else {
    tooltipMessage =
      'Template is locked and cannot be changed. Template can be unlocked by a super user.';
  }

  return (
    <Row $gap="0.2rem" $alignItems="end">
      <MdLockOutline size={IconButton_IconSizes.normal} color={COLORS.PRIMARY} />
      <Popover content={tooltipMessage}>
        <Title $type="primary">Locked template</Title>
      </Popover>
    </Row>
  );
};

export default TemplateLockedAlert;
